import { fontDisplay, fontDisplayExtraBold, lineHeightToFontSize } from 'common-react';
import { createStyles, makeStyles, Theme } from 'ui-components';

const AMOUNTS_TRANSITION_MS = 200;
const RING_SPACE = 4;

export default makeStyles((theme: Theme) => createStyles({
  root: {
    boxShadow: `inset 0 0 0 1px ${theme.color.greys[15]}`,
    padding: 40,
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      padding: 24,
    },

    [theme.breakpoints.down('xs')]: {
      padding: '24px 16px',
    },
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },

  title: {
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      font: fontDisplayExtraBold('normal', theme.fontSize.xxl, lineHeightToFontSize.xxl),
    },
  },

  stepHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },

  stepHeading: {
    [theme.breakpoints.down('xs')]: {
      font: fontDisplay('normal', theme.fontSize.l, lineHeightToFontSize.l),
    },
  },

  productList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },

  product: {
    display: 'flex',
    flexDirection: 'column',
  },

  productHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    minHeight: 24,
  },

  productLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  },

  productTooltip: {
    display: 'inline-flex',
  },

  amountsWrapper: {
    display: 'grid',
    gridTemplateRows: '1fr',
    opacity: 1,
    transition: `${AMOUNTS_TRANSITION_MS}ms ease`,
    transitionProperty: 'grid-template-rows, opacity',

    '@media (prefers-reduced-motion: reduce)': {
      transition: 'none',
    },
  },

  amountsWrapperHidden: {
    gridTemplateRows: '0fr',
    opacity: 0,
  },

  amountsClip: {
    minHeight: 0,
    overflow: 'hidden',
    margin: `0 ${-RING_SPACE}px`,
    padding: `0 ${RING_SPACE}px`,
  },

  amounts: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    paddingTop: 24,
    paddingBottom: RING_SPACE,
  },

  amountField: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 8,
    minWidth: 0,
  },

  amountInput: {
    width: '100%',

    '& .MuiFormControl-root, & .MuiInputBase-root': {
      width: '100%',
    },
  },

  limitTooltip: {
    display: 'inline-flex',
    flexShrink: 0,
    paddingBottom: 12,
  },

  submitButton: {
    width: '100%',
  },
}), { name: 'RetirementCalculatorSavings' });
